/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useLiff } from "react-liff";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { Autocomplete } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from "../../components/layout/TopBanner";
import { useDispatch } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import NotifyRepair from "../../assets/images/products/notify-repair.svg";
import CustomPopup from "../../components/popup/CustomPopup";
import { SearchProductById, CreateProductWorkOrder } from "../../services/Product";
import { SearchDdlAppointmentTime } from "../../services/Dropdown";
import { SearchMemberProfile } from "../../services/Member";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchDdlAddress } from "../../services/Dropdown";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ErrorPopup from "../../components/popup/ErrorPopup";


export default function Repair() {

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const today = new Date();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [openEditedPopup, setOpenEditedPopup] = React.useState(false);
  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);

  const [addressList, setAddressList] = React.useState([]);
  const [delayId, setDelayId] = React.useState(null);
  const [subDistrict, setSubDistrict] = React.useState(null);
  const [amphoe, setAmphoe] = React.useState(null);
  const [province, setProvince] = React.useState(null);
  const [zipCode, setZipCode] = React.useState(null);

  const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
  const [openAmphoe, setOpenAmphoe] = React.useState(false);
  const [openProvince, setOpenProvince] = React.useState(false);
  const [openZipCode, setOpenZipCode] = React.useState(false);


  const txt = {
    require: "กรุณากรอก",
    province: "จังหวัด",
    amphoe: "เขต/อำเภอ",
    tambol: "แขวง/ตำบล",
    zipCode: "รหัสไปรษณีย์",
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    setError,
    clearErrors
  } = useForm({
    defaultValues: {
      appointmentDate: null,
      appointmentTime: ''
    },
  });

  const [productInfo, setProductInfo] = React.useState(null);
  const [memberInfo, setMemberInfo] = React.useState(null);
  const [ddlAppointmentTime, setDdlAppointmentTime] = React.useState([]);

  React.useEffect(() => {
    getSearchProductById();
    getSearchDdlAppointmentTime();
    getSearchMemberProfile();
  }, []);

  async function getSearchProductById() {
    try {
      const { data } = await SearchProductById(state.productId);
      if (data.resultCode === 20000) {
        setProductInfo(data.body.info)
      }
    } catch (error) {
      console.log("getSearchProductById error", error);
    }
  }

  async function getSearchMemberProfile() {
    return await SearchMemberProfile({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          const result = response.data.body
          setMemberInfo(response.data.body)
          setValue('firstName', result.firstName)
          setValue('lastName', result.lastName)
          setValue('email', result.email)
          setValue('mobileNumber', result.mobileNumber)
          setValue('addressDetails', result.addressDetails)
          setValue('subDistrict', result.districtName)
          setValue('amphoe', result.amphoeName)
          setValue('province', result.provinceName)
          setValue('zipCode', result.zipCode)
          getSearchDefaultAddress()
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchDdlAppointmentTime() {
    try {
      const { data } = await SearchDdlAppointmentTime();
      if (data.resultCode === 20000) {
        if (data.body) {
          setDdlAppointmentTime(data.body);
        }
      }
    } catch (error) {
      console.log("getSearchDdlAppointmentTime error", error);
    }
  }

  function isValidEmail(email) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  }

  const handleChangeEmail = event => {
    if (event.target.value && !isValidEmail(event.target.value)) {
      setError('email', {
        type: "email",
        message: "อีเมลไม่ถูกต้อง"
      });
    } else {
      clearErrors('email');
    }
  };

  async function getSearchDefaultAddress() {
    try {
      if (getValues('amphoe')) {
        const search = `${getValues('subDistrict')} ${getValues('amphoe')} ${getValues('province')} ${getValues('zipCode')}`
        const { data } = await SearchDdlAddress({ params: { search } });
        if (+data["resultCode"] === 20000) {
          const body = data.body || [];
          setSubDistrict(body[0]);
          setValue("subDistrict", body[0].subDistrict);
          setValue("subDistrictId", body[0].subDistrictId);
          setAmphoe(body[0]);
          setValue("amphoe", body[0].amphoe);
          setValue("amphoeId", body[0].amphoeId);
          setProvince(body[0]);
          setValue("province", body[0].province);
          setValue("provinceId", body[0].provinceId);
          setZipCode(body[0]);
          setValue("zipCode", body[0].zipcode);
        } else {
          setAddressList([]);
        }
      }
    } catch (error) {
      console.log("getSearchDdlAddress error", error);
    }
  }

  async function getSearchDdlAddress(search) {
    try {
      const { data } = await SearchDdlAddress({ params: { search } });
      if (+data["resultCode"] === 20000) {
        const body = data.body || [];
        setAddressList(body);
      } else {
        setAddressList([]);
      }
    } catch (error) {
      console.log("getSearchDdlAddress error", error);
    }
  }

  function fnRenderOption(props, option, { inputValue }) {
    const address1 = `${option.subDistrict}, ${option.amphoe}, ${option.zipcode}`;
    const address2 = `จังหวัด ${option.province}`;

    const matches1 = match(address1, inputValue, { insideWords: true });
    const parts1 = parse(address1, matches1);

    const matches2 = match(address2, inputValue, { insideWords: true });
    const parts2 = parse(address2, matches2);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        {/*display address*/}
        <div>
          {parts1.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
        {/*display province*/}
        <div>
          {parts2.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }

  function fnOnChangeAddress(e, value) {
    fnSetOpenAddress(txt.tambol, false);
    fnSetOpenAddress(txt.amphoe, false);
    fnSetOpenAddress(txt.province, false);
    fnSetOpenAddress(txt.zipCode, false);
    setSubDistrict(value);
    setValue("subDistrictId", value.subDistrictId);
    clearErrors("subDistrictId")
    setAmphoe(value);
    setValue("amphoeId", value.amphoeId);
    clearErrors("amphoeId")
    setProvince(value);
    setValue("provinceId", value.provinceId);
    clearErrors("provinceId")
    setZipCode(value);
    setValue("zipCode", value.zipcode);
    clearErrors("zipCode")
  }

  async function onInputChangeAddress(e, type) {
    fnSetOpenAddress(type, false);
    const value = e.target.value;
    clearTimeout(delayId);
    const timeoutId = setTimeout(async () => {
      if (value) {
        await getSearchDdlAddress(value);
        fnSetOpenAddress(type, true);
      } else {
        if (type === txt.tambol) {
          setValue('subDistrictId', null)
        } else if (type === txt.amphoe) {
          setValue('amphoeId', null)
        } else if (type === txt.province) {
          setValue('provinceId', null)
        } else if (type === txt.zipCode) {
          setValue('zipCode', null)
        }
        setAddressList([]);
      }
    }, 500);
    setDelayId(timeoutId);
  }

  function fnSetOpenAddress(type, open) {
    if (type === txt.tambol) {
      setOpenSubDistrict(open);
    } else if (type === txt.amphoe) {
      setOpenAmphoe(open);
    } else if (type === txt.province) {
      setOpenProvince(open);
    } else if (type === txt.zipCode) {
      setOpenZipCode(open);
    }
  }

  function fnOnChangeAppointmentTime(event) {
    console.log(event)
  }

  const onSubmit = (data) => {
    setMemberInfo(data)
    setOpenEditedPopup(true)
  };

  async function postCreateProductWorkOrder() {
    try {

      let payload = {
        productWarrantyId: state.productId,
        appointmentDate: dayjs(memberInfo.appointmentDate).add(7, 'hours'),
        appointmentTime: memberInfo.appointmentTime,
        description: memberInfo.description,
        userName: memberInfo.firstName + ' ' + memberInfo.lastName,
        userEmail: memberInfo.email,
        userTel: memberInfo.mobileNumber,
        userAddress: `${memberInfo.addressDetails} ${zipCode.name}`,
        addressDetails: memberInfo.addressDetails,
        amphoe: memberInfo.amphoeId,
        district: memberInfo.subDistrictId,
        province: memberInfo.provinceId,
        zipCode: memberInfo.zipCode,
      }


      Object.keys(payload).forEach(key => {
        if (payload[key] === null) {
          delete payload[key];
        }
      });

      const { data } = await CreateProductWorkOrder({ data: payload });
      if (+data["resultCode"] === 20000) {
        navigate("/user-products");
      } else {
        setOpenErrorPopup(true)
      }
    } catch (error) {
      console.log("postCreateMember error", error);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <ErrorPopup
          open={openErrorPopup}
          actionFunction={() => {
            setOpenErrorPopup(false)
          }}
        />
        <CustomPopup
          title={"ยืนยันการแจ้งซ่อม"}
          desc={
            "คุณยืนยันการแจ้งซ่อม\nสำหรับสินค้าของคุณใช่หรือไม่"
          }
          cancelFunction={() => {
            setOpenEditedPopup(false);
          }}
          actionText={"ยืนยัน"}
          actionFunction={() => {
            postCreateProductWorkOrder()
          }}
          open={openEditedPopup}
          onClose={() => {
            setOpenEditedPopup(false);
          }}
        />
        <CustomPopup
          title={"ยกเลิกการใช้บริการ"}
          desc={
            "ข้อมูลผู้ใช้ที่เปลี่ยนแปลง \n ยังไม่ถูกบันทึก คุณต้องการยกเลิกการแก้ไขใช่หรือไม่"
          }
          cancelFunction={() => {
            setOpenCancelPopup(false);
          }}
          actionText={"ยืนยัน"}
          actionFunction={() => {
            setOpenCancelPopup(false);
            navigate(-1);
          }}
          open={openCancelPopup}
          onClose={() => {
            setOpenCancelPopup(false);
          }}
        />
        <TopLogo />
        <TopBanner type="product" />
        <Container maxWidth="xl" className="mt-[-40px]">
          <div className="">
            <img src={NotifyRepair} alt="logo" style={{ width: "100%" }} />
          </div>
          <div className="bg-white" style={{ padding: "0 10px" }}>
            <div className="px-[10px]">
              <div className="flex gap-[10px] justify-start  pt-[20px]">
                <div className="primary-color title-size">ข้อมูลสินค้า</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size">Product Information</p>
                  <div className="blue-line"></div>
                </div>
              </div>
            </div>
            {productInfo &&
              <div className="w-full px-[10px] pb-[40px]">
                <div>
                  <InputLabel
                    className="text-header1 text-left"
                    htmlFor="txtEmail"
                  >
                    ยี่ห้อ
                  </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    disabled
                    value={productInfo.brandName}
                  />
                </div>
                <div className="mt-2">
                  <InputLabel className="text-header1 text-left">
                    ประเภท
                  </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    disabled
                    value={productInfo.typeName}
                  />
                </div>
                <div className="mt-2">
                  <InputLabel className="text-header1 text-left">
                    ชื่อรุ่น
                  </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    disabled
                    value={productInfo.code}
                  />
                </div>
                <div className="mt-2">
                  <InputLabel required className="text-header1 text-left">
                    รหัสสินค้า (Model Code)
                  </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    disabled
                    value={productInfo.modelName}
                  />
                </div>
                <div className="mt-2">
                  <InputLabel required className="text-header1 text-left">
                    หมายเลขเครื่อง (Serial Number)
                  </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    disabled
                    value={productInfo.serialNumber}
                  />
                </div>
                <div className="relative mt-2">
                  <InputLabel
                    required={true}
                    className="text-header1 text-left"
                    htmlFor=""
                  >
                    วันที่ซื้อ
                  </InputLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      className="w-full"
                      inputFormat="DD/MM/YYYY"
                      name="Date"
                      disabled
                      value={productInfo.buyDate}
                      renderInput={(params) => (
                        <TextField
                          name="Date"
                          {...params}
                          placeholder="วันที่ซื้อสินค้า"
                        />
                      )}
                    />
                    <img
                      className={
                        `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                        (!!errors?.Date ? "bottom-[42px]" : null)
                      }
                      src={calendar}
                      alt=""
                    />
                  </LocalizationProvider>
                  {/* )}
                /> */}
                </div>

                <div className="px-[0px]">
                  <div className="flex gap-[10px] justify-start  pt-[20px]">
                    <div className="primary-color title-size">ข้อมูลบริการ</div>
                    <div style={{ marginTop: "6px" }}>
                      <p className="sub-title-size">Service Information</p>
                      <div className="blue-line"></div>
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <InputLabel className="text-header1 text-left text-required">วันที่ต้องการนัด </InputLabel>
                  <Controller
                    name="appointmentDate"
                    control={control}
                    rules={{
                      required: "กรุณากรอกวันที่ต้องการนัดบริการ",
                    }}
                    render={({ field }) => (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                          {...field}
                          className="w-full"
                          inputFormat="DD/MM/YYYY"
                          minDate={today}
                          name="Date"
                          onChange={(date) => field.onChange(date)}
                          selected={field.value}
                          renderInput={(params) => (
                            <TextField
                              name="Date"
                              {...params}
                              error={!!errors?.appointmentDate}
                              helperText={errors?.appointmentDate?.message}
                              placeholder="วันที่ต้องการนัดบริการ"
                            />
                          )}
                        />
                        <img
                          className={
                            `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                            (!!errors?.appointmentDate ? "bottom-[42px]" : null)
                          }
                          src={calendar}
                          alt=""
                        />
                      </LocalizationProvider>
                    )}
                  />
                </div>

                <div className={errors?.appointmentDate ? '' : 'mt-2'}>
                  <InputLabel className="text-header1 text-left text-required">เวลาที่ต้องการนัด </InputLabel>
                  <Controller
                    name="appointmentTime"
                    control={control}
                    rules={{
                      required: "กรุณาเลือกเวลาที่ต้องการนัด",
                    }}
                    render={({ field }) => (
                      <FormControl fullWidth error={!!errors?.appointmentTime}>
                        <Select
                          {...field}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem disabled value="">
                            <span style={{ color: "#B7B7B7" }}>เวลาที่ต้องการนัดบริการ</span>
                          </MenuItem>
                          {ddlAppointmentTime.length > 0 &&
                            ddlAppointmentTime.map((item, i) => (
                              <MenuItem value={item.id} key={i}>
                                {item.name}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>กรุณาเลือกเวลาที่ต้องการนัด</FormHelperText>
                      </FormControl>
                    )}
                  />
                </div>
                <div className={errors?.appointmentTime ? '' : 'mt-2'}>
                  <InputLabel required className="text-header1 text-left text-required">รายละเอียด </InputLabel>
                  <TextField
                    id=""
                    fullWidth
                    requuired
                    placeholder="ข้อมูลเพิ่มเติมในการขอใช้บริการ"
                    error={!!errors?.description}
                    helperText={errors?.description?.message}
                    {...register("description", { required: "กรุณากรอกข้อมูลเพิ่มเติม" })}
                  />
                </div>

                <div className="px-[0px]">
                  <div className="flex gap-[10px] justify-start  pt-[20px]">
                    <div className="primary-color title-size">ข้อมูลบริการ</div>
                    <div style={{ marginTop: "6px" }}>
                      <p className="sub-title-size">Service Information</p>
                      <div className="blue-line"></div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  <InputLabel className="text-header1 text-left text-required">ชื่อ </InputLabel>
                  <InputLabel className="text-header1 text-left text-required">นามสกุล </InputLabel>
                </div>
                <div className="grid grid-cols-2 gap-5">
                  <TextField
                    id="txtFirstName"
                    required
                    fullWidth
                    placeholder="ชื่อของคุณ"
                    error={!!errors?.firstName}
                    helperText={errors?.firstName?.message}
                    {...register("firstName", { required: "กรุณากรอกชื่อ" })}
                  />
                  <TextField
                    id="txtLastName"
                    required
                    fullWidth
                    placeholder="นามสกุลของคุณ"
                    error={!!errors?.lastName}
                    helperText={errors?.lastName?.message}
                    {...register("lastName", { required: "กรุณากรอกนามสกุล" })}
                  />
                </div>

                <div className={errors?.firstName || errors?.lastName ? '' : ' mt-2'}>
                  <InputLabel className="text-header1 text-left text-required">อีเมล </InputLabel>
                  <TextField
                    id="txtEmail"
                    fullWidth
                    placeholder="อีเมลของคุณ"
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                    {...register("email", {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "อีเมลไม่ถูกต้อง"
                      }
                      ,
                      required: "กรุณากรอกอีเมล"
                    })
                    }
                    onChange={handleChangeEmail}
                  />
                </div>

                <div className={errors?.email ? '' : 'mt-2'}>
                  <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">เบอร์โทรศัพท์ </InputLabel>
                  <TextField
                    id="txtMobileNumber"
                    fullWidth
                    required
                    type="number"
                    error={!!errors?.mobileNumber}
                    helperText={errors?.mobileNumber?.message}
                    placeholder="เบอร์โทรศัพท์ของคุณ"
                    {...register("mobileNumber", { required: "กรุณากรอกเบอร์โทรศัพท์" })}
                  // onChange={handleChangeEmail}
                  />
                </div>

                <div className="px-[0px]">
                  <div className="flex gap-[10px] justify-start  pt-[20px]">
                    <div className="primary-color title-size">ที่อยู่</div>
                    <div style={{ marginTop: "6px" }}>
                      <p className="sub-title-size">Address</p>
                      <div className="blue-line"></div>
                    </div>
                  </div>
                </div>

                <div className="">
                  <InputLabel className="text-header1 text-left text-required">ที่อยู่ </InputLabel>
                  <TextField
                    required
                    id="txtEmail"
                    fullWidth
                    placeholder="ที่อยู่ของคุณ"
                    error={!!errors?.addressDetails}
                    helperText={errors?.addressDetails?.message}
                    {...register("addressDetails", { required: "กรุณากรอกที่อยู่" })}
                  />
                </div>

                <div className={errors?.addressDetails ? "grid grid-cols-2 gap-2" : "grid grid-cols-2 gap-2 mt-2"}>
                  <InputLabel required={true} className="text-header1 text-left text-required">แขวง / ตำบล </InputLabel>
                  <InputLabel required={true} className="text-header1 text-left text-required">เขต / อำเภอ </InputLabel>
                </div>
                <div className="grid grid-cols-2 gap-5">
                  <Controller
                    name="subDistrictId"
                    control={control}
                    rules={{
                      required: "กรุณากรอกแขวง/ตำบล",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        disableClearable
                        onChange={fnOnChangeAddress}
                        options={addressList}
                        open={openSubDistrict}
                        onClose={() => fnSetOpenAddress(txt.tambol, false)}
                        getOptionLabel={(option) => option.subDistrict}
                        value={subDistrict}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="พิมพ์แขวง/ตำบล"
                            error={!!errors?.subDistrictId}
                            helperText={errors?.subDistrictId?.message}
                            onInput={(e) => onInputChangeAddress(e, txt.tambol)}
                          />
                        )}
                        renderOption={fnRenderOption}
                      />
                    )}
                  />

                  <Controller
                    name="amphoeId"
                    control={control}
                    rules={{
                      required: "กรุณากรอกเขต/อำเภอ",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        disableClearable
                        onChange={fnOnChangeAddress}
                        options={addressList}
                        open={openAmphoe}
                        onClose={() => fnSetOpenAddress(txt.amphoe, false)}
                        getOptionLabel={(option) => option.amphoe}
                        value={amphoe}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="พิมพ์เขต/อำเภอ"
                            error={!!errors?.amphoeId}
                            helperText={errors?.amphoeId?.message}
                            onInput={(e) => onInputChangeAddress(e, txt.amphoe)}
                          />
                        )}
                        renderOption={fnRenderOption}
                      />
                    )}
                  />

                </div>

                <div className={(errors?.amphoeId || errors?.subDistrictId) ? "" : "mt-2"}>
                  <InputLabel className="text-header1 text-left text-required">จังหวัด </InputLabel>
                  <Controller
                    name="provinceId"
                    control={control}
                    rules={{
                      required: "กรุณากรอกจังหวัด",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        disableClearable
                        onChange={fnOnChangeAddress}
                        options={addressList}
                        open={openProvince}
                        onClose={() => fnSetOpenAddress(txt.province, false)}
                        getOptionLabel={(option) => option.province}
                        value={province}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="พิมพ์จังหวัด"
                            error={!!errors?.provinceId}
                            helperText={errors?.provinceId?.message}
                            onInput={(e) => onInputChangeAddress(e, txt.province)}
                          />
                        )}
                        renderOption={fnRenderOption}
                      />
                    )}
                  />
                </div>

                <div className={errors?.provinceId ? "" : "mt-2"}>
                  <InputLabel className="text-header1 text-left text-required">รหัสไปรษณีย์ </InputLabel>
                  <Controller
                    name="zipCode"
                    control={control}
                    rules={{
                      required: "กรุณากรอกรหัสไปรษณีย์",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        disableClearable
                        onChange={fnOnChangeAddress}
                        options={addressList}
                        open={openZipCode}
                        onClose={() => fnSetOpenAddress(txt.zipCode, false)}
                        getOptionLabel={(option) => option.zipcode}
                        value={zipCode}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="พิมพ์รหัสไปรษณีย์"
                            error={!!errors?.zipCode}
                            helperText={errors?.zipCode?.message}
                            onInput={(e) => onInputChangeAddress(e, txt.zipCode)}
                          />
                        )}
                        renderOption={fnRenderOption}
                      />
                    )}
                  />
                </div>
              </div>
            }
          </div>
        </Container>

        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton
              variant="outlined"
              className="w-[40%]"
              onClick={() => setOpenCancelPopup(true)}
            >
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton
              variant="contained"
              className="w-[40%]"
              type="submit"
            >
              แจ้งซ่อม
            </PrimaryButton>
          </Stack>
        </div>
      </form>
    </>
  );
}
